import { Navigate } from "react-router-dom";

import { ModalEmail } from "~/components/kiosk/ui/modals/checkout/email";
import { ModalEmailError } from "~/components/kiosk/ui/modals/checkout/email/email-error";
import { ModalEmailLoading } from "~/components/kiosk/ui/modals/checkout/email/email-loading";
import { ModalEmailSuccess } from "~/components/kiosk/ui/modals/checkout/email/email-success";
import { useOrderEmail } from "~/hooks/queries/orders";
import { useKioskSession } from "~/stores/kiosk-session/hooks/use-kiosk-session";
import { useKioskSessionReset } from "~/stores/kiosk-session/hooks/use-kiosk-session-reset";

import { useKioskStore } from "../__app.kiosk/route";

export const KioskEmailPage = () => {
  const user = useKioskStore((state) => state.user);
  const orderId = useKioskSession((session) => session?.orderId);

  const { mutate: sendEmail, status: emailStatus, reset } = useOrderEmail();

  const resetSession = useKioskSessionReset();

  if (!orderId) {
    return <Navigate to="/kiosk/basket" />;
  }

  if (emailStatus === "pending") {
    return <ModalEmailLoading />;
  }

  if (emailStatus === "error") {
    return <ModalEmailError onClick={reset} />;
  }

  if (emailStatus === "success") {
    return <ModalEmailSuccess onClose={resetSession} />;
  }

  return (
    <ModalEmail
      onSendReceipt={(email) => {
        sendEmail({ orderId, email, userId: user?.id ?? null });
      }}
      onGoBack={resetSession}
    />
  );
};
